import React from 'react';
import styles from 'src/components/TopNavbar/TopNavbar.styles';
import { Button } from '@material-ui/core';
import './Logout.scss';
import BrandLogo from '../../images/S5Logo-White-NoInnovation-Centered.png';

// TODO: Delete me
export const Logout = (props: { message: string; onLogin: () => void }) => {
  return (
    <React.Fragment>
      <nav className={styles.mainNavBar}>
        <span className="logo-container">
          <img className="logo" src={BrandLogo} alt="" data-qa="TopNavHomeIcon" />
        </span>
      </nav>
      <div
        style={{ height: '500px' }}
        className={'logout'}
      >
        <div>{props.message}</div>
        <Button variant="contained" onClick={props.onLogin}>
          Login
        </Button>
      </div>
    </React.Fragment>
  );
};
